import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import styles from "./login.module.scss"
import { useLogin } from "./useLogin"
import Box from "@mui/material/Box"
import Form from "../../components/Form"
import LoginStates from "./Features/LoginStates"

const Login = () => {
    const { states, functions } = useLogin()

    const formData = {
        fields: [
            {
                type: "text",
                label: `${functions.translate("technicianName")}`,
                name: "name",
                placeholder: "Enter Technician Name",
                required: true,
                labelFontWeight: 500
            },
            {
                type: "number",
                label: `${functions.translate("technicianNumber")}`,
                name: "phone",
                placeholder: "Enter Technician Number",
                labelFontWeight: 500,
                required: true,
            },
            {
                type: "text",
                label: `${functions.translate("uniqueCode")}`,
                name: "vendor_code",
                placeholder: "-----",
                labelFontWeight: 500,
                required: true,
                text: `${functions.translate("siteVerificationText")}`
            },
        ],
    }

    const renderLoginForm = () => {
        if (states.loginError && states.loader) {
            return <Box className={styles.login_wrapper}>
                <LoginStates
                    loading={states.loader}
                    error={states.loginError ? true : false}
                />
            </Box>
        }
        else if (states.loader) {
            return <Box className={styles.login_wrapper}>
                <LoginStates
                    loading={states.loader}
                />
            </Box>
        }
        else {
            return <Box className={styles.login_wrapper}>
                <Box className={styles.form_wrapper}>
                    <Typography className={styles.form_wrapper__heading}>
                        {functions.translate("greetings")}
                    </Typography>
                    <Typography className={styles.form_wrapper__sub_heading}>
                        {functions.translate("welcome")}
                    </Typography>
                    <form onSubmit={states.formik.handleSubmit}>
                        <Form {...{ data: formData, formik: states.formik }} />
                        <Box className={styles.form_wrapper__button_container}>
                            <Button
                                loading={states.isLoginLoading}
                                size="small"
                                variant="outlined"
                                type="submit"
                                disabled={process.env.REACT_APP_DISABLE_COMMISSIONING === "true"}
                            >
                                {functions.translate("verify")}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Box>
        }
    }

    return renderLoginForm()
}

export default Login
